export { default } from './PanelWrapper';


// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/index.js